import * as exportInvoices from 'store/actions/invoices/exportInvoices';
import * as fetchInvoices from 'store/actions/invoices/fetchInvoices';
import * as requests from 'http/requests/invoicesRequests';
import * as types from 'store/actions/types';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchInvoicesAsync({ payload }) {
    const {
        onError,
        onSuccess,
        ...params
    } = payload;

    try {
        const response = yield requests.fetchInvoices(params);

        yield put(fetchInvoices.fetchInvoicesSuccess(response));

        if (onSuccess) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchInvoices.fetchInvoicesFailure(error));

        if (onError) {
            yield onError(error);
        }
    }
}

function* exportInvoicesAsync({ payload }) {
    try {
        yield requests.exportInvoices(payload);

        yield put(exportInvoices.exportInvoicesSuccess());

        yield put(showNotification('resources.invoices.export.success', 'success'));
    } catch (error) {
        yield put(exportInvoices.exportInvoicesFailure(error));
    }
}

function* exportInvoicesLinesAsync({ payload }) {
    try {
        yield requests.exportInvoicesLines(payload);

        yield put(exportInvoices.exportInvoicesLinesSuccess());

        yield put(showNotification('resources.invoices.export.success', 'success'));
    } catch (error) {
        yield put(exportInvoices.exportInvoicesLinesFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* invoicesSagas() {
    yield [
        takeEvery(types.FETCH_INVOICES, fetchInvoicesAsync),
        takeEvery(types.FETCH_INVOICES_FAILURE, failureMessage),

        takeEvery(types.EXPORT_INVOICES, exportInvoicesAsync),
        takeEvery(types.EXPORT_INVOICES_FAILURE, failureMessage),

        takeEvery(types.EXPORT_INVOICES_LINES, exportInvoicesLinesAsync),
        takeEvery(types.EXPORT_INVOICES_LINES_FAILURE, failureMessage),

        takeEvery(types.EXPORT_INVOICES, exportInvoicesAsync),
        takeEvery(types.EXPORT_INVOICES_FAILURE, failureMessage),

        takeEvery(types.DOWNLOAD_INVOICES_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/invoices/invoicesSagas.js